import type { Finding } from "./types.js";

function precedence(finding: Finding): number {
  if (finding.source === "manual") return 5;
  if (finding.source === "dictionary") return 4;
  if (finding.status === "validated" && (finding.category === "secret" || ["iban", "payment_card", "se_personnummer", "se_samordningsnummer", "dk_cpr", "lt_personal_code"].includes(finding.rawType))) return 3;
  if (finding.status === "validated") return 2;
  return finding.source === "model" ? 0 : 1;
}

function overlaps(left: Finding, right: Finding): boolean {
  return left.startUtf16 < right.endUtf16 && right.startUtf16 < left.endUtf16;
}

export function resolveOverlaps(candidates: readonly Finding[]): { findings: Finding[]; suppressedFindings: Finding[] } {
  const ordered = [...candidates].sort((left, right) =>
    precedence(right) - precedence(left)
    || (right.endUtf16 - right.startUtf16) - (left.endUtf16 - left.startUtf16)
    || right.confidence - left.confidence
    || left.startUtf16 - right.startUtf16
    || left.id.localeCompare(right.id),
  );
  const findings: Finding[] = [];
  const suppressedFindings: Finding[] = [];
  for (const candidate of ordered) {
    if (findings.some((selected) => overlaps(selected, candidate))) suppressedFindings.push(candidate);
    else findings.push(candidate);
  }
  findings.sort((left, right) => left.startUtf16 - right.startUtf16 || left.endUtf16 - right.endUtf16 || left.id.localeCompare(right.id));
  suppressedFindings.sort((left, right) => left.startUtf16 - right.startUtf16 || left.id.localeCompare(right.id));
  return { findings, suppressedFindings };
}
